import PropTypes from 'prop-types';
import React from 'react';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import { navigateToProjectReports } from '../../../links/index.jsx';

SurveyFilter.propTypes = {
  selectedOption: PropTypes.oneOf(['true']),
};

SurveyFilter.defaultProps = {
  selectedOption: undefined,
};

const handleSelect = (survey) =>
  navigateToProjectReports({
    survey: survey === 'all' ? undefined : survey,
  });

function SurveyFilter({ selectedOption }) {
  return (
    <div className="flex-col report-filter">
      <div className="text-muted filter-label">Feedback Form</div>
      <ButtonToolbar>
        <DropdownButton
          bsStyle="info"
          title={selectedOption === 'true' ? 'Has Feedback Form' : 'All'}
          id="survey-filter"
          className="btn-block text-capitalize"
          onSelect={handleSelect}
          pullRight
        >
          <MenuItem active={!selectedOption} eventKey="all">
            All
          </MenuItem>
          <MenuItem divider />
          <MenuItem active={selectedOption === 'true'} eventKey="true">
            Has Feedback Form
          </MenuItem>
        </DropdownButton>
      </ButtonToolbar>
    </div>
  );
}

export default SurveyFilter;
